const Solicitar = () => {
  return (
    <div className="relative w-full bg-[#00245D] grid grid-cols-1 md:grid-cols-2 py-32">
      <div className="absolute top-0 left-0 w-full overflow-hidden">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1920 323.84"
          className="w-full h-32"
          preserveAspectRatio="none"
        >
          <path
            d="M0,0V327.44S426.28,86.28,930.72,197.19C1849,399.07,1920,0,1920,0Z"
            fill="white"
          />
        </svg>
      </div>
      <div className="w-full flex flex-col text-white justify-center p-16">
        <h2 className="text-2xl md:text-5xl font-bold mb-2">
          Hablemos de su proyecto
        </h2>
        <p className="">
          Rellene el formulario o llame para concertar una reunión a <br/> (52) 2224596783
        </p>
      </div>
      <form className="w-full rounded-xl p-6 flex flex-col gap-4">
        <input
          type="text"
          placeholder="Nombre completo"
          className="border-0 border-b-2 border-white bg-transparent px-4 py-2 focus:outline-none focus:ring-2 focus:ring-sky-400"
        />
        <input
          type="email"
          placeholder="Correo electrónico"
          className="border-0 border-b-2 border-white bg-transparent px-4 py-2 focus:outline-none focus:ring-2 focus:ring-sky-400"
        />
        <input
          type="tel"
          placeholder="Teléfono"
          className="border-0 border-b-2 border-white bg-transparent px-4 py-2 focus:outline-none focus:ring-2 focus:ring-sky-400"
        />
        <input
          type="text"
          placeholder="Ciudad desde la que escribe"
          className="border-0 border-b-2 border-white bg-transparent px-4 py-2 focus:outline-none focus:ring-2 focus:ring-sky-400"
        />
        <textarea
          rows="4"
          placeholder="Mensaje"
          className="border-0 border-b-2 border-white bg-transparent px-4 py-2 focus:outline-none focus:ring-2 focus:ring-sky-400 resize-none"
        ></textarea>

        <button
          type="submit"
          className="w-full bg-sky-700 text-white py-3 rounded-full font-semibold hover:bg-sky-800 transition"
        >
          Enviar solicitud
        </button>
      </form>
    </div>
  );
};

export default Solicitar;
